// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { deleteProduct, fetchProductsList, updateProductStatus } from "../../../Redux/Slices/productCatalogSlice";

// Custom layout
import MainLayout from "../../../Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../Assets";
import sample from "../../../Assets/Images/sampleProduct.png"
import Modal from "../../../Components/Common/Modal";

//utils
import { notifySuccess } from "Services/Utils/toastNotification";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";



const ProductCatalog = () => {

  const location = useLocation();
  console.log(location,'ppp')
  const [search, setSearch] = useState(location.state?.search || "");
  console.log("Search on returning:", search);


  const headerDetails = [
    {
      label: "S No",
      sortKey: false,
    },
    {
      label: "Product Image",
      sortKey: false,
    },
    {
      label: "Product Name",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "product_name"})
      },
    },
    {
      label: "Category",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "category_name"})
      },
    },
    {
      label: "Sub Category",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "sub_category_name"})
      },
    },
    {
      label: "Status",
      sortKey: true,
      singleClickFunc:() => {
        setSortOptions({sort_by: !sortOptions.sort_by, order_by: "status"})
      },
    },
  ];
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rowsPerPage = 10;
  const [productList, setProductList] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1)
  const [openMenuId, setOpenMenuId] = useState(null);
  const [sortOptions, setSortOptions] = useState({ sort_by: false, order_by: "name" });
  // const [search, setSearch] = useState('')
  // to trigger rerender after status change
  const [productStatus, setProductStatus] = useState(1)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setSearch(value)
  };

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
    // console.log(openMenuId)
  };

  const handleOutsideClick = (e) => {
    // Check if clicked outside and if the menu is open
    if (openMenuId !== null && !e.target.closest(".optionsMenu")) {
      setOpenMenuId(null); // Close the menu if clicked outside
    }
  };

  const changeStatus = (status,id) => {
    if(status ===  3 ){
      status = 2
    }
    else{
      status = 3
    }
    dispatch(
      updateProductStatus({
        data:{
          status:status,
          id:id
        },
        callBack: productStatusChangeCB,
      })
    )
  }
  
  const deleteIndividualProduct = ()=>{
    dispatch(
      deleteProduct({
      data:{
        id:productToDelete
      },
      callBack: deleteProductCB,
    }))
    setIsModalOpen(false);
  }

  useEffect(() => {
    setCurrentPage(1)
  }, [search])

  useEffect(() => {
    setIsLoading(true)  
    dispatch(
      fetchProductsList({
        data: {
          search:search,
          page: currentPage,
          limit:"10",
          sort_by:sortOptions.sort_by?"ASC":"DESC",
          order_by: sortOptions.order_by,
          role:"3"
        },
        callBack: productListCB,
      })
    );
  },[sortOptions,currentPage,productStatus,search])

  const productListCB = (value) => {
    console.log(value)
    setProductList(value?.data?.data_list || [])
    setTotalPage(value?.data?.pageMeta?.totalPages || 1)
    setTotalCount(value?.data?.pageMeta?.total || 0);
    setIsLoading(false)
  };

  const productStatusChangeCB = (value) => {
    //triggers rerender after status change
    setProductStatus(!productStatus)
    //closes the options menu
    setOpenMenuId(null)
  };

  const deleteProductCB = (value) => {
    console.log(value)
     notifySuccess("Product Deleted Successfully")
     //triggers rerender after status change
     setProductStatus(!productStatus)
     //closes the options menu
     setOpenMenuId(null)
  }

  //  // Function to show the modal
 const openDeleteConfirmationModal = (product_catalog_id) => {
  setProductToDelete(product_catalog_id);
  console.log(product_catalog_id)
  console.log(productToDelete)
  setIsModalOpen(true);
  setOpenMenuId(null)
};

  useEffect(() => {
    // Add the event listener with a slight delay to allow the toggleMenu logic to complete
    const timer = setTimeout(() => {
      document.addEventListener("click", handleOutsideClick);
    }, 0);
  
    // Clean up event listener on unmount or when the component re-renders
    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openMenuId]);


  return (
    <MainLayout pageName={"Product Catalog"}>
      <div className="staffManagementContainer">
        <div className="staffManagementHeader">
          <div className="staffSearchBox">
            <InputBox
              value={search}
              icon={assets.Icons.searchIcon}
              onChange={handleChange}
              inputStyle={{
                padding: "1px 2vh 1px 7vh",
                border: "none",
                height: "7vh",
                width: "25vw",
                borderRadius: "0px",
                color: 'black'
              }}
              placeholder="Search"
            />
            <p className="totalCount">
  Total count : {totalCount}
</p>
          </div>
          <div className="addNewStaffButton" onClick={()=>navigate('addProductCatalog')}>
            <Button buttonStyle={{ height: "1vh" }} title="Add Product" />
          </div>
        </div>
        <div className="staffManagementTable">
          <NormalTable
            headerDetails={headerDetails}
            // pagination={true}
          >
            {productList.length > 0
              ? productList.map((list,index) => {
                  return (
                    <>
                      <tr
                        key={list.product_catalog_id}
                        className="border"
                        style={{ position: "relative" }}
                      >
                        <td style={{paddingLeft:"20px"}}>
                        {search ? index + 1 : (currentPage - 1) * 10 + (index + 1)}
                          </td>
                        <td>
                          {list?.product_catalog_images[0] ? (
                            <img
                              style={{ height: "35px" }}
                              src={list.product_catalog_images[0]}
                              alt="productIcon"
                            />
                          ): <p>No Data</p> } 
                        </td>
                        <td> {list?.product_name?.length > 30
                          ? `${list?.product_name.slice(0, 30)}...`
                          : list?.product_name}</td>
                        <td>{list.category_name}</td>
                        <td>{list.sub_category_name}</td>
                        <td
                          style={{
                            color: `${
                              list.status === 2 ? "#10CA23" : "#FF482F"
                            }`,
                          }}
                        >
                          {list.status === 2 ? "Active" : "Inactive"}
                        </td>
                        <td>
                          <img
                            style={{ height: "15px", cursor: "pointer" }}
                            src={assets.Icons.optionsIcon}
                            alt="Options"
                            onClick={() => toggleMenu(list.product_catalog_id)} // Open menu for this row
                          />
                          {openMenuId === list.product_catalog_id && (
                            <div className="optionsMenu">
                              <ul>
                                <li
                                  onClick={() =>
                                    navigate(
                                      `viewProductCatalog/${list.product_catalog_id}/${list.category_id}/${list.filteration_type_id ? list.filteration_type_id : ""}`, { state: { search } }
                                    )
                                  }
                                >
                                  <img src={assets.Icons.viewIcon} alt="" />
                                  View
                                </li>
                                <li
                                  onClick={() =>
                                    navigate(
                                      `editProductCatalog/${list.product_catalog_id}/${list.category_id}`, 
                                    )
                                  }
                                >
                                  <img src={assets.Icons.editIcon} alt="" />
                                  Edit
                                </li>
                                <li
                                  onClick={() =>
                                    openDeleteConfirmationModal(list.product_catalog_id)
                                  }
                                >
                                  <img src={assets.Icons.deleteIcon} alt="" />
                                  Delete
                                </li>
                                <li
                                  onClick={() =>
                                    changeStatus(list.status, list.product_catalog_id)
                                  }
                                >
                                  <img
                                    src={assets.Icons.activeInactiveIcon}
                                    alt=""
                                  />
                                  Mark as{" "}
                                  {list.status === 2 ? "Inactive" : "Active"}
                                </li>
                              </ul>
                            </div>
                          )}
                        </td>
                      </tr>
                    </>
                  );
                })
              : " "}
          </NormalTable>
          <Modal open={isModalOpen} closeModal={() => {
            setIsModalOpen(false);
            setProductToDelete(null);
          }}>
              <h3 style={{ textAlign:'center', fontFamily:'Roboto' }}>Are you sure you want to delete this Product?</h3>
            <div style={{ display:'flex', flexDirection:'row', justifyContent:'space-around', paddingTop:'20px' }}>
              <Button
              buttonStyle={{
                width: "40%",
                height: "2vh",
              }}
               title='Delete'
               onClick={deleteIndividualProduct}
              />
              <Button
                  buttonStyle={{
                    height: "2vh",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid black",
                    width: "40%",
                  }}
                  titleStlye={{ color: "#888888" }}
                  title="Cancel"
                  onClick={() => {
                    setIsModalOpen(false);
                    setProductToDelete(null); 
                  }}
                />
            </div>
          </Modal>
          {productList.length > 0 ? '' :<p style={{textAlign:'center', fontFamily:'poppins', fontSize:"4vh"}}>{isLoading ? "Loading" : "No Data Found" }</p>}
          {productList.length > 0 ?
          <Pagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={handlePageChange}
          /> : ''}
        </div>
      </div>
    </MainLayout>
  );
};

export default ProductCatalog;


